import { useAccountSabaCoinWallet } from '@/hooks/query/account';
import { BetsTicketData } from '../../bets-ticket-types';
import { useCashOutContext } from '../../contexts/cashout-context';
import { BetsGroup } from '../bets-group'

type BetsListProps = {
	isCashout: boolean;
	ticket: BetsTicketData;
	ticketIndex?: number;
	isAside?: boolean | undefined;
	showBackToMatchTipTicketId?: string;
	isOutSabaCoinSelected?: boolean;
}

export const BetsList = ({
	isCashout,
	ticket,
	ticketIndex,
	isAside,
	showBackToMatchTipTicketId,
	isOutSabaCoinSelected
}: BetsListProps) => {
	const { deleteTicketList } = useCashOutContext();
	const { data: sabaCoinWallet } = useAccountSabaCoinWallet();
	return isCashout ? (
		ticket.betList.filter(ticketData => ticketData.IsCashOut && !deleteTicketList.includes(ticketData.TransID)).map((ticketData) => (
			<BetsGroup
				ticketData={ticketData}
				key={ticketData.TransID}
				isSettled={false}
				isOpenDefault={true}
				isAside={isAside}
			/>
		))
	) : (
		ticket.betList.filter(ticketData => !deleteTicketList.includes(ticketData.TransID)).map((ticketData, ticketDataIndex) => (
			<BetsGroup
				ticketData={ticketData}
				key={`${ticketData.TransID}_${ticketDataIndex}_${sabaCoinWallet}`}
				isSettled={false}
				isOpenDefault={
					isAside ? (
						(ticketIndex === 0 && ticketDataIndex === 0) ? true : false
					) : true
				}
				showBackToMatchTipTicketId={showBackToMatchTipTicketId}
				isSabaCoinSelected={isOutSabaCoinSelected}
				isAside={isAside}
			/>
		))
	)
}